//@ts-nocheck

import React, { useContext, useState } from 'react'
import * as S from './Input.styles'

import Icon from '../../../atoms/Icon/Icon.component'
import { Paragraph } from '../../../atoms/Typography/Typography.component'
import { SpacerBase } from '../../../atoms/GridSystem'
import { useField } from 'formik'
import { SectionThemeContext } from '../../../../contexts/SectionTheme.context'

const Input = ({ label, password, withFeedback, uppercase, withBackground, ...props}) => {
  const { selectedColorScheme } = useContext(SectionThemeContext)
  const [ removeMask, setRemoveMask ] = useState(false)
  const [ field, meta ] = useField(props)
  const hasError = meta.touched && !!meta.error
  const errorId = `${props.name}-error`

  const handleToggleMask = () => setRemoveMask(prev => !prev)

  return (
    <>
      <S.Input 
        error={hasError && props.type !== 'hidden'}
        uppercase={uppercase}
        disabled={props.disabled}
        $hidden={props.type === 'hidden'}
        colorScheme={selectedColorScheme}
        withBackground={withBackground}
      >
        {label && props.type !== 'hidden' ? (
          <Paragraph typo={'paragraphXS'} as="label" htmlFor={props.id || props.name}>
            {label + (props?.required ? ' *' : '')}
          </Paragraph>
        ) : null}
        <input
          {...field}
          {...props}
          id={props.id || props.name}
          type={removeMask ? 'text' : props.type}
          placeholder={props.placeholder}
          aria-invalid={hasError}
          aria-describedby={hasError ? errorId : undefined}
        />
        { props.type === 'password' ? (
          <S.InputToggleShow
            as="button"
            type="button"
            onClick={handleToggleMask}
            aria-label={removeMask ? 'Hide password' : 'Show password'}
          >
            <Icon name={'eye'} useIconColor unlockedProportions/>
          </S.InputToggleShow>
        ) : null}
        { field.value !== '' && !meta.error && withFeedback ? (
          <S.InputCorrectFeedback aria-hidden="true">
            <Icon name={'check-circle'}/>
          </S.InputCorrectFeedback>
        ) : null}
      </S.Input>
      
      {props.helperText && !hasError ? (
        <S.InputHelperText colorScheme={selectedColorScheme} withBackground={withBackground}>
          <SpacerBase xs={1} />
          {props.helperText}
        </S.InputHelperText>
      ) : null}

      {hasError ? (
        <S.InputError id={errorId} role="alert">
          <SpacerBase xs={1} />
          {meta.error}
        </S.InputError>
      ) : null}
    </>
  )
}

export default Input
